import useMe from 'data/hooks/useMe';

const useConnect = () => {
  const { me } = useMe();

  return {
    me,
  };
};

export default useConnect;
